import { Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-incident-risk-profile',
  templateUrl: './incident-risk-profile.component.html',
  styleUrls: ['./incident-risk-profile.component.scss'],
})
export class IncidentRiskProfileComponent {
  @Input() set chartHeight(val: any) {
    if (val) this.height = val + 'px';
  }
  height = '';
  chartOption: EChartsOption = {
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      data: ['CRITICAL', 'OTHERS'],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    },
    yAxis: {
      type: 'value',
    },
    series: [
      {
        name: 'CRITICAL',
        type: 'line',
        stack: 'Total',
        data: [120, 132, 101, 134, 90, 230, 210],
      },
      {
        name: 'OTHERS',
        type: 'line',
        stack: 'Total',
        data: [220, 182, 191, 234, 290, 330, 310],
      },
    ],
  };
}
